import { render, staticRenderFns } from "./AdminAgroUnidadesMedida.vue?vue&type=template&id=2a44f310&"
import script from "./AdminAgroUnidadesMedida.vue?vue&type=script&lang=js&"
export * from "./AdminAgroUnidadesMedida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports